import o, { useState as u, useMemo as O, useEffect as T } from "react";
import { TextField as v, EmailField as G, CountryCodePhoneField as Q, TextareaField as W, Checkbox as $ } from "@amenitiz/design-system";
import { useAtomValue as D } from "jotai";
import { searchResultsAtom as j } from "./index58.mjs";
import { selectedClientDetailsAtom as J } from "./index55.mjs";
import { Dropdown as X } from "./index195.mjs";
import { FieldState as a } from "./index196.mjs";
import { FIRST_NAME_FIELD as _, LAST_NAME_FIELD as E, COUNTRY_FIELD as L, EMAIL_FIELD as H, COUNTRY_CODE_FIELD as N, PHONE_COUNTRY_FIELD as A, PHONE_NUMBER_FIELD as k, REQUEST_FIELD as f } from "./index56.mjs";
import d from "./index197.mjs";
import { getConfigPropertyAtomCreator as Z, ConfigProperty as ee } from "./index13.mjs";
import { Address as te } from "./index198.mjs";
import { useClientDetailsStep as oe } from "./index199.mjs";
import { useTracking as ne } from "./index88.mjs";
import { GUEST_INFO_HASH as ie } from "./index87.mjs";
import { validateForm as re } from "./index200.mjs";
import { track as C } from "./index9.mjs";
import { TRACK_EVENT_TYPE as y, TRACK_EVENT as h } from "./index10.mjs";
import ae from "./index79.mjs";
import { isEmailValid as le } from "./index201.mjs";
import { useHotelConfig as se } from "./index93.mjs";
import { getSubscriptionPlanRoot as b } from "./index14.mjs";
import { generateFieldId as l } from "./index181.mjs";
const Re = () => {
  ne(ie);
  const { setClientDetails: i, setSummaryButton: S } = oe(), t = D(J), [M, V] = u(!1), [x, K] = u([]), [z, Y] = u(!1), r = O(
    () => ({
      firstName: l(_, "client-details"),
      lastName: l(E, "client-details"),
      country: l(L, "client-details"),
      email: l(H, "client-details"),
      phone: l(k, "client-details"),
      request: l(f, "client-details"),
      consent: l(
        "consent_communicate_by_phone",
        "client-details"
      )
    }),
    []
  ), { hotelId: s, propertySize: m, propertyType: c, subscriptionPlan: p } = se(), B = D(
    O(
      () => Z(ee.IS_FULL_ADDRESS_REQUIRED),
      []
    )
  ), R = () => {
    const e = t.email;
    return e === "" || le(e) ? a.DEFAULT : a.ERROR;
  }, [w, U] = u(
    R()
  ), g = B === "true", I = D(j);
  T(() => {
    const e = re(t, g);
    S({
      disabled: !e
    });
  }, [t, g, S]), T(() => {
    ae.getCountries().then((e) => {
      K(e);
    });
  }, []), T(() => {
    C(h.VIEW, y.VIEW_GUEST_INFO_PAGE, {
      hotel_id: s,
      property_type: c,
      property_size: m,
      subscription_plan: b(p)
    });
  }, [s, m, c, p]);
  const F = x.sort(
    (e, n) => e.country_name.localeCompare(n.country_name)
  ), P = (e) => {
    C(h.CLICK, y.COUNTRY_CLICKED, {
      hotel_id: s,
      property_type: c,
      property_size: m,
      subscription_plan: b(p)
    });
    const n = F.find(
      (q) => q.country_code === e || q.country_name.toLowerCase() === e.toLowerCase()
    );
    i({
      [L]: (n == null ? void 0 : n.country_code) || "",
      [A]: (n == null ? void 0 : n.country_code) || "",
      [N]: (n == null ? void 0 : n.phone_code) || ""
    });
  };
  return /* @__PURE__ */ o.createElement(
    "div",
    {
      className: d.client_details_container,
      id: "client-details-step",
      "data-testid": "client-details-step"
    },
    /* @__PURE__ */ o.createElement("h4", { "data-testid": "client-details-title", className: d.title }, I18n.t("booking_engine.information.title")),
    /* @__PURE__ */ o.createElement(
      v,
      {
        required: !0,
        autocomplete: "given-name",
        id: r.firstName,
        name: _,
        key: _,
        label: I18n.t("booking_engine.information.name"),
        placeholder: I18n.t("booking_engine.information.name_placeholder"),
        onChange: (e) => {
          i({
            [_]: e
          });
        },
        value: t[_],
        state: a.DEFAULT
      }
    ),
    /* @__PURE__ */ o.createElement(
      v,
      {
        autocomplete: "family-name",
        id: r.lastName,
        key: E,
        name: E,
        label: I18n.t("booking_engine.information.last_name"),
        placeholder: I18n.t("booking_engine.information.last_name_placeholder"),
        onChange: (e) => {
          i({
            [E]: e
          });
        },
        value: t.last_name,
        required: !0,
        state: a.DEFAULT
      }
    ),
    /* @__PURE__ */ o.createElement(
      X,
      {
        id: r.country,
        name: L,
        label: I18n.t("booking_engine.information.country"),
        placeholder: `- ${I18n.t(
          "booking_engine.information.select_country"
        )} -`,
        required: !0,
        selectedOption: t.country,
        onChange: P,
        options: F.map((e) => ({
          label: e.country_name,
          value: e.country_code
        }))
      }
    ),
    g ? /* @__PURE__ */ o.createElement(te, { setCountry: P }) : null,
    /* @__PURE__ */ o.createElement(
      G,
      {
        autocomplete: "email",
        id: r.email,
        name: H,
        required: !0,
        label: I18n.t("booking_engine.information.email"),
        placeholder: I18n.t("booking_engine.information.email_placeholder"),
        value: t.email,
        onChange: (e) => {
          M || (C(h.CLICK, y.EMAIL_SELECTED, {
            hotel_id: s,
            property_type: c,
            property_size: m,
            subscription_plan: b(p)
          }), V(!0)), i({
            email: e
          });
        },
        onFocus: () => U(a.DEFAULT),
        onBlur: () => U(R()),
        state: w
      }
    ),
    /* @__PURE__ */ o.createElement(
      Q,
      {
        autocomplete: "tel",
        hotelCountryCode: t.country,
        id: r.phone,
        name: "phone",
        required: !0,
        label: I18n.t("booking_engine.information.phone"),
        countryCodes: F,
        additionalClasses: d.phone_container,
        countryCodePlaceholder: "+00",
        placeholder: "000000000",
        value: {
          country_code: t[N],
          country: t[A],
          phone_number: t[k]
        },
        onChange: (e) => {
          z || (C(h.CLICK, y.PHONE_NUMBER_SELECTED, {
            hotel_id: s,
            property_type: c,
            property_size: m,
            subscription_plan: b(p)
          }), Y(!0)), i({
            [A]: e.country,
            [N]: e.country_code,
            [k]: e.phone_number.replace(/\D/g, "")
          });
        },
        state: a.DEFAULT
      }
    ),
    /* @__PURE__ */ o.createElement(
      W,
      {
        autocomplete: "off",
        id: r.request,
        key: f,
        name: f,
        classes: d.textarea,
        label: I18n.t("simple_form.labels.cart_customer.request"),
        placeholder: I18n.t("simple_form.placeholders.cart_customer.request"),
        onChange: (e) => {
          i({
            [f]: e
          });
        },
        value: t.request,
        required: !1,
        state: a.DEFAULT
      }
    ),
    I != null && I.consent_communication_checkbox ? /* @__PURE__ */ o.createElement("div", { className: d.consent_communicate_by_phone }, /* @__PURE__ */ o.createElement(
      $,
      {
        id: r.consent,
        onChange: () => {
          i({
            consent_communicate_by_phone: !t.consent_communicate_by_phone
          });
        },
        value: !t.consent_communicate_by_phone,
        "aria-labelledby": "consent-label"
      }
    ), /* @__PURE__ */ o.createElement("span", { id: "consent-label" }, I18n.t("booking_engine.authorisation.bloctel_opt_out"))) : null
  );
};
export {
  Re as ClientDetailsStep
};
